const materials = [
  {
    id: "M_Tyre_Mitas_AC65",
    color: 0x1a1a1a,
    roughness: 0.7,
    metalness: 0,
    map: "T_AC65_ORM",
    roughnessMap: "T_AC65_ORM",
    normalMap: "T_AC65_N",
    aoMap: "T_AC65_ORM",
    //normalScale: [-1.3, -1.3],
    type: "MeshStandardMaterial",
    envMapIntensity: 0.5,
  },
  {
    id: "M_Tyre_Trelleborg_TM800",
    color: 0x1a1a1a,
    roughness: 0.7,
    metalness: 0,
    map: "T_TM800_ORM",
    roughnessMap: "T_TM800_ORM",
    normalMap: "T_TM800_N",
    aoMap: "T_TM800_ORM",
    //normalScale: [-1.3, -1.3],
    type: "MeshStandardMaterial",
    envMapIntensity: 0.5,
  },
  {
    id: "M_Cluster_A85",
    roughness: 0.1,
    metalness: 0,
    color: 0x000000,
    emissive: 0xffffff,
    emissiveMap: "T_AGCO-Valtra-Middle line_Styling_LED ON",
    emissiveIntensity: 1,
    type: "MeshPhysicalMaterial",
  },
];

export default materials;
